import React from 'react';
import BackButton from '../components/BackButton';
import GlassBox from '../components/GlassBox';

function GlassBoxPage() {
  return (
    <>
      <BackButton />
      <GlassBox />
    </>
  );
}

export default GlassBoxPage;
